import Product from '../../components/search/suggestion/product';

/**
 * @param {Array} products
 * @param {Number} highlightedIndex
 *
 * @returns {Array}
 */
export function productRenderer(products, highlightedIndex) {
    return products.map((product) => {
        return (
            <Product
                manufacturer={product.manufacturer}
                details={product.details}
                dimensions={product.dimensions}
                price={product.price}
                imageUrl={product.productImage}
                productUrl={product.url}
                currency={product.currency}
                isHighlighted={() => highlightedIndex(product.index)}
            />
        );
    })
}
